export default "__VITE_ASSET__CllCaMCp__"